import { defineMessages } from 'react-intl'

const messages = defineMessages({
  option: {
    id: 'EvolutionFilter.option',
    description: 'Opcion para seleccionar años de evolución',
    defaultMessage: '{years, plural, one{# año} other{# años}}'
  }
})

export default messages



// WEBPACK FOOTER //
// ./src/modules/Filters/EvolutionFilter/messages.js